import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

export function DecisionFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();

  return (
    <Picker
      showActionBar
      selectedKeys={params.client_decision?.split(",") || []}
      onSelectionChange={(keys) =>
        setParam("client_decision", Array.from(keys))
      }
      label={t("Decision")}
      items={[
        { id: "MEETS_CRITERIA", name: t("Meets criteria") },
        { id: "CRITERIA_NOT_MET", name: t("Criteria not met") },
      ]}
      selectionMode="multiple"
      testID="decision-filter"
    />
  );
}
